import { createRouter, createWebHistory } from 'vue-router'
import KuponJajan from '../views/KuponJajan.vue'
import KuponJajanA1de from '../views/KuponJajanA1de.vue'
import KuponJajanMMS from '../views/KuponJajanMMS.vue'
import Welcome from '../views/WelcomeImg.vue'
import Welcome2 from '../views/WelcomeImg2.vue'
import Welcome3 from '../views/WelcomeImg3.vue'
import HujanKupon from '../views/Hujan.vue'
import NotFound from '../views/NotFoundView.vue'
import KuponTelur from '../views/KuponTelur.vue'
import Waiting from '../views/Waiting.vue'
import Waiting2 from '../views/Waiting2.vue'
import Waiting3 from '../views/Waiting3.vue'
import Waiting4 from '../views/Waiting4.vue'
import WaitChat from '../views/Waitchat.vue'

const routes = [
  {
    path: '/waiting/:waptoken?',
    name: 'Waiting',
    component: Waiting,
    meta: { 
      title: 'Menunggu Kupon Jajan Kamu, dan Tukar Kuota s/d 10GB!',
      description:  'Waiting — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.',
    }
  },
  {
    path: '/waiting2/:waptoken?',
    name: 'Waiting2',
    component: Waiting2,
    meta: { 
      title: 'Menunggu Kupon Jajan Kamu, dan Tukar Kuota s/d 10GB!',
      description:  'Waiting2 — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.',
    }
  },
  {
    path: '/waiting3/:sid?',
    name: 'Waiting3',
    component: Waiting3,
    meta: { 
      title: 'Menunggu Kupon Jajan Kamu, dan Tukar Kuota s/d 10GB!',
      description:  'Waiting3 — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.',
    }
  },
  {
    path: '/waiting4/:waptoken?',
    name: 'Waiting4',
    component: Waiting4,
    meta: { 
      title: 'Menunggu Kupon Jajan Kamu, dan Tukar Kuota s/d 10GB!',
      description:  'Waiting4 — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.',
    }
  },
  {
    path: '/waitchat/:sid?',
    name: 'WaitChat',
    component: WaitChat,
    meta: { 
      title: 'Tunggu sebentar! Kami lagi nyambungin kamu ke chat.',
      description:  'Waiting — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.',
    }
  },
  {
    path: '/kt',
    name: 'KuponTelur',
    component: KuponTelur,
    meta: { 
      title: 'Ambil Kupon Jajan kamu, Tukar KUOTA s/d 10GB!',
      description: 'KT — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },  
  {
    path: '/ktmms',
    name: 'KuponTelurMMS',
    component: KuponTelur,
    meta: { 
      title: 'Ambil Kupon Jajan kamu, Tukar KUOTA s/d 10GB!',
      description: 'KT - ktmms — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/pecahkan-tukar',
    name: 'PecahkanTukar',
    component: KuponTelur,
    meta: { 
      title: 'Ambil Kupon Jajan kamu, Tukar KUOTA s/d 10GB!',
      description: 'Pecahkan Tukar — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },  
  {
    path: '/hk',
    name: 'HujanKupon',
    component: HujanKupon,
    meta: { 
      title: 'Tangkap Kupon Jajan kamu, Tukar KUOTA s/d 10GB!',
      description: 'HK — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },  
  {
    path: '/hkmms',
    name: 'HujanKuponMMS',
    component: HujanKupon,
    meta: { 
      title: 'Tangkap Kupon Jajan kamu, Tukar KUOTA s/d 10GB!',
      description: 'HK - hkmms — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/tangkap-tukar',
    name: 'TangkapTukar',
    component: HujanKupon,
    meta: { 
      title: 'Tangkap Kupon Jajan kamu, Tukar KUOTA s/d 10GB!',
      description: 'Tangkap Tukar — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },  
  {
    path: '/kj',
    name: 'KuponJajan',
    component: KuponJajan,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Kupon Jajan — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/spw',
    name: 'KuponJajan - spw',
    component: KuponJajan,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Kupon Jajan — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/a1de',
    name: 'KuponJajan - a1de',
    component: KuponJajanA1de,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Kupon Jajan — a1de — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/kjmms',
    name: 'KuponJajan - kjmms',
    component: KuponJajanMMS,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Kupon Jajan — kjmms — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/gosok-tukar',
    name: 'KuponJajan - GosokTukar',
    component: KuponJajanMMS,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Gosok Tukar — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/kjw',
    name: 'KuponJajan - kjw',
    component: KuponJajan,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Kupon Jajan — kjw — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/id4',
    name: 'KuponJajan - id4',
    component: KuponJajan,
    meta: { 
      title: 'Gosok Kupon Jajan kamu, Tukar KUOTA s/d 10GB',
      description: 'Kupon Jajan — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },  
  {
    path: '/welcome',
    name: 'KuponJajan - Welcome',
    component: Welcome,
    meta: { 
      title: 'Tukarkan Kupon Jajan kamu di sini!',
      description: 'Kupon Jajan — Welcome — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/welcome2',
    name: 'KuponJajan - Welcome2',
    component: Welcome2,
    meta: { 
      title: 'Tukarkan Kupon Jajan kamu di sini!',
      description:  'Kupon Jajan — Welcome2 — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/welcome3',
    name: 'KuponJajan - Welcome3',
    component: Welcome3,
    meta: { 
      title: 'Tukarkan Kupon Jajan kamu di sini!',
      description:  'Kupon Jajan — Welcome3 — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { 
      title: 'Landing - Not Found',
      description: 'Kupon Jajan — Dapatkan kupon gratis setiap hari dan tukarkan dengan pulsa atau kuota favoritmu! Mainkan game seru, kumpulkan poin, dan raih hadiah menarik langsung dari HP kamu.'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
